import { Tag as AntdTag, Flex } from 'antd';
import cx from 'clsx';
import React from 'react';
import styles from './index.module.scss';

const Tag = ({
  value,
  checked,
  handleChange = () => {},
  disable = false,
  isCheckAble = true,
  handleClose = () => {},
  closable = true,
  className = '',
  suffix = null,
}) => {
  const TagComponent = isCheckAble ? AntdTag?.CheckableTag : AntdTag;

  return (
    <div onClick={isCheckAble ? () => {} : handleChange} className={cx(styles.tag, className)}>
      <TagComponent
        key={value}
        disabled={disable}
        onChange={(checked) => {
          return disable || handleChange(value, checked);
        }}
        {...(isCheckAble
          ? {
              checked: checked,
            }
          : {
              closable: closable,
              onClose: handleClose,
            })}
      >
        <Flex gap={5} align="center">
          {value}
          {suffix}
        </Flex>
      </TagComponent>
    </div>
  );
};

export default Tag;
